/**
 * LessonService - Quản lý và cache danh sách bài học có sẵn
 * Tự động scan và lưu vào biến tạm để trang BaiHoc có thể lọc nhanh
 */

export interface LessonItem {
  id: string
  lop: number
  chuong: number
  bai: number
  tenBai: string
  moTa: string
  hasContent: boolean
  lessonUrl: string
}

class LessonService {
  // Biến tạm lưu trữ danh sách bài học đã scan
  private cachedLessons: LessonItem[] = []
  private isScanned: boolean = false
  private isScanning: boolean = false
  private scanPromise: Promise<LessonItem[]> | null = null

  // Pre-defined lesson manifest - eliminates network requests
  private readonly LESSON_MANIFEST = new Set([
    'lop-10/chuong-0-mo-dau/bai-1-gioi-thieu-muc-dich-hoc-tap-mon-vat-li',
    'lop-10/chuong-1-dong-hoc/bai-2-do-dich-chuyen-va-quang-duong-di-duoc',
    'lop-10/chuong-1-dong-hoc/bai-3-toc-do-va-van-toc-chuyen-dong-tong-hop',
    'lop-10/chuong-1-dong-hoc/bai-4-do-thi-do-dich-chuyen-thoi-gian',
    'lop-10/chuong-1-dong-hoc/bai-5-chuyen-dong-bien-doi',
    'lop-10/chuong-1-dong-hoc/bai-6-chuyen-dong-roi-tu-do',
    'lop-10/chuong-1-dong-hoc/bai-7-chuyen-dong-nem',
    'lop-10/chuong-2-dong-luc-hoc/bai-8-ba-dinh-luat-newton-ve-chuyen-dong',
    'lop-10/chuong-2-dong-luc-hoc/bai-9-mot-so-luc-trong-thuc-tien',
    'lop-10/chuong-2-dong-luc-hoc/bai-10-tong-hop-luc-va-phan-tich-luc',
    'lop-10/chuong-2-dong-luc-hoc/bai-11-can-bang-luc-moment-luc',
    'lop-10/chuong-2-dong-luc-hoc/bai-12-khoi-luong-rieng-ap-suat-chat-long',
    'lop-10/chuong-3-nang-luong-va-cong/bai-13-cong-va-nang-luong',
    'lop-10/chuong-3-nang-luong-va-cong/bai-14-dong-nang-va-the-nang',
    'lop-10/chuong-3-nang-luong-va-cong/bai-15-cong-suat-va-hieu-suat',
    'lop-10/chuong-3-nang-luong-va-cong/bai-16-dong-luong-dinh-luat-bao-toan-dong-luong',
    'lop-10/chuong-3-nang-luong-va-cong/bai-17-dong-luong-va-va-cham',
    'lop-10/chuong-4-chuyen-dong-tron-va-bien-dang/bai-18-dong-hoc-chuyen-dong-tron-deu',
    'lop-10/chuong-4-chuyen-dong-tron-va-bien-dang/bai-19-gia-toc-huong-tam-va-luc-huong-tam',
    'lop-10/chuong-4-chuyen-dong-tron-va-bien-dang/bai-20-su-bien-dang-dinh-luat-hooke',
    'lop-11/chuong-1-dao-dong/bai-1-dao-dong-dieu-hoa-phuong-trinh-dao-dong-dieu-hoa',
    'lop-11/chuong-1-dao-dong/bai-2-van-toc-gia-toc-trong-dao-dong-dieu-hoa',
    'lop-11/chuong-1-dao-dong/bai-3-nang-luong-trong-dao-dong-dieu-hoa',
    'lop-11/chuong-1-dao-dong/bai-4-dao-dong-tat-dan-cuong-buc-cong-huong',
    'lop-11/chuong-2-song/bai-5-mo-ta-song-su-truyen-song',
    'lop-11/chuong-2-song/bai-6-cac-dac-trung-cua-song-song-doc-va-song-ngang',
    'lop-11/chuong-2-song/bai-7-song-dien-tu',
    'lop-11/chuong-2-song/bai-8-giao-thoa-song',
    'lop-11/chuong-2-song/bai-9-song-dung',
    'lop-11/chuong-2-song/bai-10-do-toc-do-truyen-am',
    'lop-11/chuong-3-dien-truong/bai-11-luc-tuong-tac-giua-cac-dien-tich-dinh-luat-coulomb',
    'lop-11/chuong-3-dien-truong/bai-12-khai-niem-dien-truong-dien-truong-deu',
    'lop-11/chuong-3-dien-truong/bai-13-dien-the-va-the-nang-dien',
    'lop-11/chuong-3-dien-truong/bai-14-dien-dung-va-tu-dien-nang-luong-dien-truong',
    'lop-11/chuong-4-dong-dien-mach-dien/bai-15-dong-dien-cuong-do-dong-dien',
    'lop-11/chuong-4-dong-dien-mach-dien/bai-16-dien-tro-dinh-luat-ohm',
    'lop-11/chuong-4-dong-dien-mach-dien/bai-17-nguon-dien',
    'lop-11/chuong-4-dong-dien-mach-dien/bai-18-nang-luong-dien-cong-suat-dien',
    'lop-12/chuong-1-vat-li-nhiet/bai-1-su-chuyen-the',
    'lop-12/chuong-1-vat-li-nhiet/bai-2-noi-nang-dinh-luat-1-cua-nhiet-dong-luc-hoc',
    'lop-12/chuong-1-vat-li-nhiet/bai-3-thang-nhiet-do-nhiet-ke',
    'lop-12/chuong-1-vat-li-nhiet/bai-4-nhiet-dung-rieng',
    'lop-12/chuong-1-vat-li-nhiet/bai-5-nhiet-nong-chay-rieng',
    'lop-12/chuong-1-vat-li-nhiet/bai-6-nhiet-hoa-hoi-rieng',
    'lop-12/chuong-2-khi-li-tuong/bai-7-mo-hinh-dong-hoc-phan-tu-chat-khi',
    'lop-12/chuong-2-khi-li-tuong/bai-8-dinh-luat-boyle',
    'lop-12/chuong-2-khi-li-tuong/bai-9-dinh-luat-charles',
    'lop-12/chuong-2-khi-li-tuong/bai-10-phuong-trinh-trang-thai-cua-khi-li-tuong',
    'lop-12/chuong-2-khi-li-tuong/bai-11-ap-suat-theo-mo-hinh-dong-hoc-phan-tu-dong-nang-phan-tu',
    'lop-12/chuong-3-tu-truong/bai-12-tu-truong',
    'lop-12/chuong-3-tu-truong/bai-13-luc-tu-tac-dung-len-doan-day-dan-mang-dong-dien-cam-ung-tu',
    'lop-12/chuong-3-tu-truong/bai-14-tu-thong-hien-tuong-cam-ung-dien-tu',
    'lop-12/chuong-3-tu-truong/bai-15-may-phat-dien-xoay-chieu-dai-cuong-ve-dong-dien-xoay-chieu',
    'lop-12/chuong-3-tu-truong/bai-16-ung-dung-cua-hien-tuong-cam-ung-dien-tu',
    'lop-12/chuong-3-tu-truong/bai-17-dien-tu-truong-mo-hinh-song-dien-tu',
    'lop-12/chuong-4-vat-li-hat-nhan/bai-18-cau-truc-hat-nhan',
    'lop-12/chuong-4-vat-li-hat-nhan/bai-19-do-hut-khoi-va-nang-luong-lien-ket-hat-nhan',
    'lop-12/chuong-4-vat-li-hat-nhan/bai-20-su-phan-hach-va-tong-hop-hat-nhan',
    'lop-12/chuong-4-vat-li-hat-nhan/bai-21-phong-xa-an-toan-phong-xa',
    'lop-12/chuong-4-vat-li-hat-nhan/bai-22-cong-nghiep-hat-nhan'
  ])

  // Vietnamese lesson names - class-level constant
  private readonly VIETNAMESE_NAMES: Record<string, string> = {
    'gioi thieu muc dich hoc tap mon vat li': 'Giới thiệu mục đích học tập môn Vật lí',
    'do dich chuyen va quang duong di duoc': 'Độ dịch chuyển và quãng đường đi được',
    'toc do va van toc chuyen dong tong hop': 'Tốc độ và vận tốc - Chuyển động tổng hợp',
    'do thi do dich chuyen thoi gian': 'Đồ thị độ dịch chuyển - thời gian',
    'chuyen dong bien doi': 'Chuyển động biến đổi',
    'chuyen dong roi tu do': 'Chuyển động rơi tự do',
    'chuyen dong nem': 'Chuyển động ném',
    'ba dinh luat newton ve chuyen dong': 'Ba định luật Newton về chuyển động',
    'mot so luc trong thuc tien': 'Một số lực trong thực tiễn',
    'tong hop luc va phan tich luc': 'Tổng hợp lực và phân tích lực',
    'can bang luc moment luc': 'Cân bằng lực - Moment lực',
    'khoi luong rieng ap suat chat long': 'Khối lượng riêng - Áp suất chất lỏng',
    'cong va nang luong': 'Công và năng lượng',
    'dong nang va the nang': 'Động năng và thế năng',
    'cong suat va hieu suat': 'Công suất và hiệu suất',
    'dong luong dinh luat bao toan dong luong': 'Động lượng - Định luật bảo toàn động lượng',
    'dong luong va va cham': 'Động lượng và va chạm',
    'dong hoc chuyen dong tron deu': 'Động học chuyển động tròn đều',
    'dong hoc cua chuyen dong tron deu': 'Động học của chuyển động tròn đều',
    'gia toc huong tam va luc huong tam': 'Gia tốc hướng tâm và lực hướng tâm',
    'su bien dang dinh luat hooke': 'Sự biến dạng - Định luật Hooke',
    'dao dong dieu hoa phuong trinh dao dong dieu hoa': 'Dao động điều hòa - Phương trình dao động điều hòa',
    'van toc gia toc trong dao dong dieu hoa': 'Vận tốc - Gia tốc trong dao động điều hòa',
    'nang luong trong dao dong dieu hoa': 'Năng lượng trong dao động điều hòa',
    'dao dong tat dan dao dong cuong buc hien tuong cong huong': 'Dao động tắt dần - Dao động cưỡng bức - Hiện tượng cộng hưởng',
    'mo ta song su truyen song': 'Mô tả sóng - Sự truyền sóng',
    'cac dac trung cua song song doc va song ngang': 'Các đặc trưng của sóng - Sóng dọc và sóng ngang',
    'song dien tu': 'Sóng điện từ',
    'giao thoa song': 'Giao thoa sóng',
    'song dung': 'Sóng dừng',
    'do toc do truyen am': 'Đo tốc độ truyền âm',
    'luc tuong tac giua cac dien tich dinh luat coulomb': 'Lực tương tác giữa các điện tích - Định luật Coulomb',
    'khai niem dien truong dien truong deu': 'Khái niệm điện trường - Điện trường đều',
    'dien the va the nang dien': 'Điện thế và thế năng điện',
    'dien dung va tu dien nang luong dien truong': 'Điện dung và tụ điện - Năng lượng điện trường',
    'dong dien cuong do dong dien': 'Dòng điện - Cường độ dòng điện',
    'dien tro dinh luat ohm': 'Điện trở - Định luật Ohm',
    'nguon dien': 'Nguồn điện',
    'nang luong dien cong suat dien': 'Năng lượng điện - Công suất điện',
    'su chuyen the': 'Sự chuyển thể',
    'noi nang dinh luat 1 cua nhiet dong luc hoc': 'Nội năng - Định luật 1 của nhiệt động lực học',
    'thang nhiet do nhiet ke': 'Thang nhiệt độ - Nhiệt kế',
    'nhiet dung rieng': 'Nhiệt dung riêng',
    'nhiet nong chay rieng': 'Nhiệt nóng chảy riêng',
    'nhiet hoa hoi rieng': 'Nhiệt hóa hơi riêng',
    'mo hinh dong hoc phan tu chat khi': 'Mô hình động học phân tử chất khí',
    'dinh luat boyle': 'Định luật Boyle',
    'dinh luat charles': 'Định luật Charles',
    'phuong trinh trang thai cua khi li tuong': 'Phương trình trạng thái của khí lí tưởng',
    'ap suat theo mo hinh dong hoc phan tu dong nang phan tu': 'Áp suất theo mô hình động học phân tử - Động năng phân tử',
    'tu truong': 'Từ trường',
    'luc tu tac dung len doan day dan mang dong dien cam ung tu': 'Lực từ tác dụng lên đoạn dây dẫn mang dòng điện - Cảm ứng từ',
    'tu thong hien tuong cam ung dien tu': 'Từ thông - Hiện tượng cảm ứng điện từ',
    'may phat dien xoay chieu dai cuong ve dong dien xoay chieu': 'Máy phát điện xoay chiều - Đại cương về dòng điện xoay chiều',
    'ung dung cua hien tuong cam ung dien tu': 'Ứng dụng của hiện tượng cảm ứng điện từ',
    'dien tu truong mo hinh song dien tu': 'Điện từ trường - Mô hình sóng điện từ',
    'cau truc hat nhan': 'Cấu trúc hạt nhân',
    'do hut khoi va nang luong lien ket hat nhan': 'Độ hụt khối và năng lượng liên kết hạt nhân',
    'su phan hach va tong hop hat nhan': 'Sự phân hạch và tổng hợp hạt nhân',
    'phong xa an toan phong xa': 'Phóng xạ - An toàn phóng xạ',
    'cong nghiep hat nhan': 'Công nghiệp hạt nhân'
  }

  /**
   * Khởi tạo sẵn khi service được tạo
   * Tự động scan ngay khi import
   */
  constructor() {
    console.log('🚀 LessonService initialized, starting auto-scan...')
    this.scanAndCacheLessons().catch(error => {
      console.error('❌ Auto-scan failed:', error)
    })
  }

  /**
   * Scan tất cả các bài học có sẵn và lưu vào cache
   * Scan song song để tăng tốc
   */
  async scanAndCacheLessons(): Promise<LessonItem[]> {
    // Nếu đang scan, đợi kết quả scan hiện tại
    if (this.isScanning && this.scanPromise) {
      console.log('⏳ Scan đang chạy, đợi kết quả...')
      return this.scanPromise
    }

    // Nếu đã scan rồi, trả về cache
    if (this.isScanned && this.cachedLessons.length > 0) {
      console.log('✅ Sử dụng cache, có', this.cachedLessons.length, 'bài học')
      return this.cachedLessons
    }

    // Bắt đầu scan mới
    console.log('🔄 Bắt đầu scan bài học từ du-lieu/noi-dung...')
    this.isScanning = true

    this.scanPromise = (async () => {
      const startTime = Date.now()
      console.log('⚡ Starting FAST parallel scan of ALL lessons...')

      const lessons: LessonItem[] = []

      // Scan từng lớp
      for (let lop = 10; lop <= 12; lop++) {
        try {
          const lopLessons = await this.scanClassLessons(lop)
          lessons.push(...lopLessons)
        } catch (error) {
          console.error(`❌ Error scanning class ${lop}:`, error)
        }
      }

      // Lưu vào cache
      this.cachedLessons = lessons
      this.isScanned = true
      this.isScanning = false
      this.scanPromise = null

      const endTime = Date.now()
      const duration = ((endTime - startTime) / 1000).toFixed(2)

      console.log(`✅ Scan hoàn tất trong ${duration}s!`)
      console.log(`📊 Tìm thấy ${lessons.length} bài học`)
      console.log('📋 Cached lessons:', lessons)

      // Thống kê chi tiết
      const stats = {
        byClass: {} as Record<number, number>,
        byChapter: {} as Record<string, number>
      }

      lessons.forEach(lesson => {
        stats.byClass[lesson.lop] = (stats.byClass[lesson.lop] || 0) + 1
        const key = `L${lesson.lop}_C${lesson.chuong}`
        stats.byChapter[key] = (stats.byChapter[key] || 0) + 1
      })

      console.log('📊 Thống kê:', stats)

      return lessons
    })()

    return this.scanPromise
  }

  /**
   * Scan tất cả bài học của một lớp (OPTIMIZED: Parallel processing)
   */
  private async scanClassLessons(lop: number): Promise<LessonItem[]> {
    try {
      // Lấy danh sách các thư mục chương trong lớp
      const chuongFolders = await this.getChapterFolders(lop)

      // OPTIMIZATION: Process all chapters in parallel
      const chapterPromises = chuongFolders.map(chuongFolder =>
        this.scanChapterLessons(lop, chuongFolder).catch(error => {
          console.error(`❌ Error scanning chapter ${chuongFolder} in class ${lop}:`, error)
          return []
        })
      )

      const results = await Promise.all(chapterPromises)
      return results.flat()
    } catch (error) {
      console.error(`❌ Error scanning class ${lop}:`, error)
      return []
    }
  }

  /**
   * Lấy danh sách các thư mục chương trong một lớp
   */
  private async getChapterFolders(lop: number): Promise<string[]> {
    // Sử dụng danh sách cố định các thư mục chương đã biết
    const chapterMaps: Record<number, string[]> = {
      10: [
        'chuong-0-mo-dau',
        'chuong-1-dong-hoc',
        'chuong-2-dong-luc-hoc',
        'chuong-3-nang-luong-va-cong',
        'chuong-4-chuyen-dong-tron-va-bien-dang'
      ],
      11: [
        'chuong-1-dao-dong',
        'chuong-2-song',
        'chuong-3-dien-truong',
        'chuong-4-dong-dien-mach-dien'
      ],
      12: [
        'chuong-1-vat-li-nhiet',
        'chuong-2-khi-li-tuong',
        'chuong-3-tu-truong',
        'chuong-4-vat-li-hat-nhan'
      ]
    }

    return chapterMaps[lop] || []
  }

  /**
   * Scan tất cả bài học trong một chương
   */
  private async scanChapterLessons(lop: number, chuongFolder: string): Promise<LessonItem[]> {
    const lessons: LessonItem[] = []

    // Parse chương từ tên thư mục
    const chuongMatch = chuongFolder.match(/chuong-(\d+)/)
    if (!chuongMatch) {
      console.warn(`⚠️ Cannot parse chapter number from: ${chuongFolder}`)
      return lessons
    }

    const chuong = parseInt(chuongMatch[1])

    try {
      // Lấy danh sách các thư mục bài trong chương
      const baiFolders = await this.getLessonFolders(lop, chuongFolder)

      for (const baiFolder of baiFolders) {
        try {
          const lesson = await this.scanSingleLesson(lop, chuong, baiFolder)
          if (lesson) {
            lessons.push(lesson)
          }
        } catch (error) {
          console.error(`❌ Error scanning lesson ${baiFolder} in chapter ${chuongFolder}:`, error)
        }
      }
    } catch (error) {
      console.error(`❌ Error scanning chapter ${chuongFolder}:`, error)
    }

    return lessons
  }

  /**
   * Lấy danh sách các thư mục bài trong một chương
   */
  private async getLessonFolders(lop: number, chuongFolder: string): Promise<string[]> {
    // Sử dụng danh sách cố định các thư mục bài đã biết
    const lessonMaps: Record<string, string[]> = {
      // Lớp 10
      'lop-10/chuong-0-mo-dau': ['bai-1-gioi-thieu-muc-dich-hoc-tap-mon-vat-li'],
      'lop-10/chuong-1-dong-hoc': [
        'bai-2-do-dich-chuyen-va-quang-duong-di-duoc',
        'bai-3-toc-do-va-van-toc-chuyen-dong-tong-hop',
        'bai-4-do-thi-do-dich-chuyen-thoi-gian',
        'bai-5-chuyen-dong-bien-doi',
        'bai-6-chuyen-dong-roi-tu-do',
        'bai-7-chuyen-dong-nem'
      ],
      'lop-10/chuong-2-dong-luc-hoc': [
        'bai-8-ba-dinh-luat-newton-ve-chuyen-dong',
        'bai-9-mot-so-luc-trong-thuc-tien',
        'bai-10-tong-hop-luc-va-phan-tich-luc',
        'bai-11-can-bang-luc-moment-luc',
        'bai-12-khoi-luong-rieng-ap-suat-chat-long'
      ],
      'lop-10/chuong-3-nang-luong-va-cong': [
        'bai-13-cong-va-nang-luong',
        'bai-14-dong-nang-va-the-nang',
        'bai-15-cong-suat-va-hieu-suat',
        'bai-16-dong-luong-dinh-luat-bao-toan-dong-luong',
        'bai-17-dong-luong-va-va-cham'
      ],
      'lop-10/chuong-4-chuyen-dong-tron-va-bien-dang': [
        'bai-18-dong-hoc-chuyen-dong-tron-deu',
        'bai-19-gia-toc-huong-tam-va-luc-huong-tam',
        'bai-20-su-bien-dang-dinh-luat-hooke'
      ],

      // Lớp 11
      'lop-11/chuong-1-dao-dong': [
        'bai-1-dao-dong-dieu-hoa-phuong-trinh-dao-dong-dieu-hoa',
        'bai-2-van-toc-gia-toc-trong-dao-dong-dieu-hoa',
        'bai-3-nang-luong-trong-dao-dong-dieu-hoa',
        'bai-4-dao-dong-tat-dan-cuong-buc-cong-huong'
      ],
      'lop-11/chuong-2-song': [
        'bai-5-mo-ta-song-su-truyen-song',
        'bai-6-cac-dac-trung-cua-song-song-doc-va-song-ngang',
        'bai-7-song-dien-tu',
        'bai-8-giao-thoa-song',
        'bai-9-song-dung',
        'bai-10-do-toc-do-truyen-am'
      ],
      'lop-11/chuong-3-dien-truong': [
        'bai-11-luc-tuong-tac-giua-cac-dien-tich-dinh-luat-coulomb',
        'bai-12-khai-niem-dien-truong-dien-truong-deu',
        'bai-13-dien-the-va-the-nang-dien',
        'bai-14-dien-dung-va-tu-dien-nang-luong-dien-truong'
      ],
      'lop-11/chuong-4-dong-dien-mach-dien': [
        'bai-15-dong-dien-cuong-do-dong-dien',
        'bai-16-dien-tro-dinh-luat-ohm',
        'bai-17-nguon-dien',
        'bai-18-nang-luong-dien-cong-suat-dien'
      ],

      // Lớp 12
      'lop-12/chuong-1-vat-li-nhiet': [
        'bai-1-su-chuyen-the',
        'bai-2-noi-nang-dinh-luat-1-cua-nhiet-dong-luc-hoc',
        'bai-3-thang-nhiet-do-nhiet-ke',
        'bai-4-nhiet-dung-rieng',
        'bai-5-nhiet-nong-chay-rieng',
        'bai-6-nhiet-hoa-hoi-rieng'
      ],
      'lop-12/chuong-2-khi-li-tuong': [
        'bai-7-mo-hinh-dong-hoc-phan-tu-chat-khi',
        'bai-8-dinh-luat-boyle',
        'bai-9-dinh-luat-charles',
        'bai-10-phuong-trinh-trang-thai-cua-khi-li-tuong',
        'bai-11-ap-suat-theo-mo-hinh-dong-hoc-phan-tu-dong-nang-phan-tu'
      ],
      'lop-12/chuong-3-tu-truong': [
        'bai-12-tu-truong',
        'bai-13-luc-tu-tac-dung-len-doan-day-dan-mang-dong-dien-cam-ung-tu',
        'bai-14-tu-thong-hien-tuong-cam-ung-dien-tu',
        'bai-15-may-phat-dien-xoay-chieu-dai-cuong-ve-dong-dien-xoay-chieu',
        'bai-16-ung-dung-cua-hien-tuong-cam-ung-dien-tu',
        'bai-17-dien-tu-truong-mo-hinh-song-dien-tu'
      ],
      'lop-12/chuong-4-vat-li-hat-nhan': [
        'bai-18-cau-truc-hat-nhan',
        'bai-19-do-hut-khoi-va-nang-luong-lien-ket-hat-nhan',
        'bai-20-su-phan-hach-va-tong-hop-hat-nhan',
        'bai-21-phong-xa-an-toan-phong-xa',
        'bai-22-cong-nghiep-hat-nhan'
      ]
    }

    const key = `lop-${lop}/${chuongFolder}`
    return lessonMaps[key] || []
  }

  /**
   * Scan một bài học cụ thể
   */
  private async scanSingleLesson(lop: number, chuong: number, baiFolder: string): Promise<LessonItem | null> {
    // Parse bài từ tên thư mục
    const baiMatch = baiFolder.match(/bai-(\d+)/)
    if (!baiMatch) {
      console.warn(`⚠️ Cannot parse lesson number from: ${baiFolder}`)
      return null
    }

    const bai = parseInt(baiMatch[1])

    // Lấy tên thư mục chương từ chuong number
    const chuongFolders = await this.getChapterFolders(lop)
    const chuongFolder = chuongFolders.find(folder => folder.includes(`chuong-${chuong}`))

    if (!chuongFolder) {
      console.warn(`⚠️ Cannot find chapter folder for chapter ${chuong} in class ${lop}`)
      return null
    }

    // OPTIMIZATION: Use manifest instead of network request
    const exists = this.lessonExists(lop, chuongFolder, baiFolder)

    if (exists) {
      // Tạo tên bài học từ tên thư mục và chuyển thành tiếng Việt có dấu
      let tenBai = baiFolder.replace(`bai-${bai}-`, '').replace(/-/g, ' ')

      // OPTIMIZATION: Use class-level Vietnamese mapping
      if (this.VIETNAMESE_NAMES[tenBai.toLowerCase()]) {
        tenBai = this.VIETNAMESE_NAMES[tenBai.toLowerCase()]
      } else {
        // Nếu không tìm thấy mapping, capitalize như cũ
        tenBai = tenBai.charAt(0).toUpperCase() + tenBai.slice(1)
      }

      return {
        id: `L${lop}_C${chuong}_B${String(bai).padStart(2, '0')}`,
        lop: lop,
        chuong: chuong,
        bai: bai,
        tenBai: tenBai,
        moTa: `Lớp ${lop} - Chương ${chuong} - Bài ${bai}`,
        hasContent: true,
        lessonUrl: `/lop/${lop}/chuong/${chuong}/bai/${bai}`
      }
    }

    return null
  }


  /**
   * Kiểm tra xem bài học có tồn tại không (OPTIMIZED: No network requests)
   */
  private lessonExists(lop: number, chuongFolder: string, baiFolder: string): boolean {
    const key = `lop-${lop}/${chuongFolder}/${baiFolder}`
    return this.LESSON_MANIFEST.has(key)
  }

  /**
   * Lấy tất cả bài học từ cache (tự động scan nếu chưa có)
   */
  async getAllLessons(): Promise<LessonItem[]> {
    if (!this.isScanned) {
      return await this.scanAndCacheLessons()
    }
    return this.cachedLessons
  }

  /**
   * Lọc bài học theo điều kiện
   */
  async filterLessons(filters: {
    lop?: number
    chuong?: number
    bai?: number
    searchTerm?: string
  }): Promise<LessonItem[]> {
    const allLessons = await this.getAllLessons()
    let filtered = [...allLessons]

    // Lọc theo lớp
    if (filters.lop) {
      filtered = filtered.filter(l => l.lop === filters.lop)
    }

    // Lọc theo chương
    if (filters.chuong) {
      filtered = filtered.filter(l => l.chuong === filters.chuong)
    }

    // Lọc theo bài
    if (filters.bai) {
      filtered = filtered.filter(l => l.bai === filters.bai)
    }

    // Lọc theo từ khóa tìm kiếm
    if (filters.searchTerm) {
      const searchLower = filters.searchTerm.toLowerCase()
      filtered = filtered.filter(l =>
        l.tenBai.toLowerCase().includes(searchLower) ||
        l.moTa.toLowerCase().includes(searchLower) ||
        `lớp ${l.lop}`.toLowerCase().includes(searchLower) ||
        `chương ${l.chuong}`.toLowerCase().includes(searchLower) ||
        `bài ${l.bai}`.toLowerCase().includes(searchLower)
      )
    }

    console.log(`🔍 Filter result: ${filtered.length}/${allLessons.length} bài học`)
    return filtered
  }

  /**
   * Lấy bài học theo ID
   */
  async getLessonById(id: string): Promise<LessonItem | null> {
    const allLessons = await this.getAllLessons()
    return allLessons.find(l => l.id === id) || null
  }

  /**
   * Lấy số lượng bài học theo lớp
   */
  async getLessonCountByClass(lop: number): Promise<number> {
    const allLessons = await this.getAllLessons()
    return allLessons.filter(l => l.lop === lop).length
  }

  /**
   * Làm mới cache (force rescan)
   */
  async refreshCache(): Promise<LessonItem[]> {
    console.log('🔄 Refreshing cache...')
    this.isScanned = false
    this.cachedLessons = []
    return await this.scanAndCacheLessons()
  }

  /**
   * Lấy thống kê tổng quan
   */
  async getStatistics(): Promise<{
    total: number
    byClass: { [key: number]: number }
    byChapter: { [key: string]: number }
  }> {
    const allLessons = await this.getAllLessons()

    const byClass: { [key: number]: number } = {}
    const byChapter: { [key: string]: number } = {}

    for (const lesson of allLessons) {
      // Đếm theo lớp
      byClass[lesson.lop] = (byClass[lesson.lop] || 0) + 1

      // Đếm theo chương
      const key = `L${lesson.lop}_C${lesson.chuong}`
      byChapter[key] = (byChapter[key] || 0) + 1
    }

    return {
      total: allLessons.length,
      byClass,
      byChapter
    }
  }

  /**
   * Làm mới cache để scan lại
   */
  async rescan(): Promise<LessonItem[]> {
    console.log('🔄 Rescanning all lessons...')
    this.isScanned = false
    this.cachedLessons = []
    return await this.scanAndCacheLessons()
  }
}

// Export singleton instance
export const lessonService = new LessonService()
export default lessonService

